import { observable, action, computed, makeObservable, toJS } from 'mobx';
import qs from 'qs';

export const queryObj = qs.parse(window.location.search.replace(/^\?/, ''));

class Info {
  constructor() {
    makeObservable(this);
  }

  @observable meetingInfo: defs.api.WebMeetingInformation | null = null;
  @observable meetingId = queryObj.meetingId || 23748676;

  @action
  getMeetingInfo(): any {
    API.api.webMeetingV3.getMeetingInfo.request({ meetingId: this.meetingId }).then((res) => {
      if (res.status === 1 && res.data) {
        if (res.data?.beginTime?.match('T') && !res.data?.beginTime?.match(/[+-]08:00$/)) {
          res.data.beginTime = new Date(`${res.data?.beginTime}+08:00`).getTime();
        }
        this.meetingInfo = res.data;
      }
    });
  }
}

export default Info;
